import grpc from '@/api/request'
import { kpNotice } from '@/util/notice'

function sendMessage(params) {
  let request = {
    phone: params.phone,
    type: 4
  }
  grpc.call('/auth/notify/sms', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.code + response.msg + response.requestId)
      }
    })
    .catch(error => {
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function sendEmail(params) {
  let request = {
    email: params.email,
    type: 4
  }
  grpc.call('/auth/notify/email', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.code + response.msg + response.requestId)
      }
    })
    .catch(error => {
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function bind(params) {
  let request = {
    code: params.code,
    data: params.data,
    openId: sessionStorage.openId || null,
    type: params.type
  }
  grpc.call('/auth/agent/invite/bindWx', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.code + response.msg + response.requestId)
      }
    })
    .catch(error => {
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function getUserdata(params) {
  let request = {
    agentStaffId: params.agentStaffId
  }
  grpc.call('/agent/agent/staff/part_info', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.code + response.msg + response.requestId)
      }
    })
}
export {
  sendMessage,
  sendEmail,
  bind,
  getUserdata

}



// WEBPACK FOOTER //
// ./src/controller/login.js